import { checkSessionIsValid } from '@/services/api/sessionValidation'
import loadEmployeePhoto from '@/components/use/employeePhoto'
import resetStore from '@/components/use/resetStore'
import config from '@/config'
import Log from '@/utilities/Log'
import { storeToRefs } from 'pinia'
import { useSessionStore } from '@/storage/session'

export async function sessionValidator(): Promise<boolean> {
  const { siteSessionId } = storeToRefs(useSessionStore())
  const userCheckedIn = siteSessionId.value !== null

  // The employee photo's bytes are deliberately not persisted, so a restored session holds the
  // reference and nothing to show until it asks for the content again (B40). Ahead of the
  // check-in test on purpose: a user who has logged in but not yet checked in is on their way to
  // the screen that shows it. Fire-and-forget, exactly as at login.
  void loadEmployeePhoto()

  if (!userCheckedIn) {
    return true
  }

  const response = await checkSessionIsValid()

  if (!response.sessionIsValid) {
    resetStore()
    Log.storeReset('sessionValidation.ts')
    window.location.replace(config.redirects.sessionExpired)
  }

  return response.sessionIsValid
}
